import {Mask} from './Mask';
import {MaskImpl} from './MaskImpl';

export class MaskINN extends MaskImpl implements Mask {

    public normalize(value: string): string {
        if (!value) {
            return value;
        }
        return value.toString().replace(/[^\d]/g, '').slice(0, 12);
    }

}
